import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import ScrollAnimation from 'react-animate-on-scroll'

import { white } from 'styles/colors'
import { media, mediaDown } from 'styles/media'
import { H3, H4, fontWeights, lineHeights } from 'styles/typography'
import * as spacing from 'styles/spacing'

import Section from 'components/Section'
import Wrapper from 'components/Wrapper'
import Button from 'components/button/Button'

const Container = styled.div`
  position: static;

  ${mediaDown.medium`
    text-align: center;
  `};
`

const Inner = styled.div`
  position: relative;
  z-index: 10;

  ${media.medium`
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: space-between;
  `};
`

const Main = styled.main`
  position: static;

  ${mediaDown.medium`
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  `};

  ${media.medium`
    padding-left: ${spacing.xxLarge};
    margin-bottom: 0;
    max-width: 580px;
  `};

  ${media.large`
    padding-left: 56px;
    padding-right: ${spacing.large};
  `};

  ${media.xLarge`
    padding-left: 88px;
    max-width: 660px;
  `};
`

const Heading = styled(H3)`
  color: ${white};
  text-transform: uppercase;
  margin-bottom: ${spacing.medium};

  ${media.medium`
    margin-bottom: ${spacing.large};
  `};

  ${media.xLarge`
    margin-bottom: ${spacing.xLarge};
  `};
`

const Subheading = styled(H4)`
  color: ${white};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights.base};
  margin-bottom: ${spacing.large};

  ${media.medium`
    margin-bottom: ${spacing.xLarge};
  `};

  ${media.xLarge`
    margin-bottom: ${spacing.xxLarge};
  `};
`

const FigureWrap = styled.div`
  flex-shrink: 0;
  display: block;

  ${mediaDown.medium`
    margin-left: auto;
    margin-right: auto;
    max-width: 500px;
  `};

  ${media.medium`
    width: 440px;
    margin-left: -${spacing.xLarge};
    margin-top: -${spacing.large};
    margin-bottom: -${spacing.large};
  `};

  ${media.large`
    width: 520px;
    margin-top: -${spacing.xLarge};
    margin-bottom: -${spacing.xLarge};
  `};

  ${media.xLarge`
    width: 560px;

  `};
`

const FastestRoute = () => (
  <Container>
    <Section>
      <Wrapper>
        <Inner>
          <Main>
            <Heading as={ScrollAnimation} animateIn="fadeInUp" offset={0} animateOnce>
              Subscribe to accelerate your vuse+ membership
            </Heading>
            <Subheading as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={200} animateOnce>
              Spend over $100 to become a Vuse+ member. Your monthly subscription orders will automatically speed up
              your membership qualification. You can then benefit from even more discounts.
            </Subheading>
            <ScrollAnimation animateIn="fadeInUp" offset={0} delay={400} animateOnce>
              <Button to="/vuse-plus-vape-deals/" theme="custom" customColor={white} variant="outline" size="large">
                Learn more
              </Button>
            </ScrollAnimation>
          </Main>
          <Link to="/vuse-plus-vape-deals/">
            <FigureWrap as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={600} animateOnce>
              <img src={`${process.env.BASE_PATH}/images/vype-plus/card-stack.png`} alt="vype plus vape deals" />
            </FigureWrap>
          </Link>
        </Inner>
      </Wrapper>
    </Section>
  </Container>
)

export default FastestRoute
